// The staff session, in one place. Three call sites need it — the console, the
// upload queue, and the print sheet — and a second copy of the storage key is
// exactly how a "why is it asking me to sign in again" bug gets born.
import type { StaffSession, StaffUser } from "./api";

export const STAFF_TOKEN_KEY = "laqta.staff.token";
const STAFF_USER_KEY = "laqta.staff.user";
const STAFF_EXP_KEY = "laqta.staff.exp";

/**
 * sessionStorage, not localStorage: the session dies with the tab, the same
 * property the PIN had. On a shared venue laptop that is the point — closing
 * the browser signs the operator out.
 */
export function saveSession(s: StaffSession): void {
  sessionStorage.setItem(STAFF_TOKEN_KEY, s.token);
  sessionStorage.setItem(STAFF_USER_KEY, JSON.stringify(s.user));
  sessionStorage.setItem(STAFF_EXP_KEY, s.expiresAt);
}

export function clearSession(): void {
  sessionStorage.removeItem(STAFF_TOKEN_KEY);
  sessionStorage.removeItem(STAFF_USER_KEY);
  sessionStorage.removeItem(STAFF_EXP_KEY);
}

export function staffToken(): string {
  return sessionStorage.getItem(STAFF_TOKEN_KEY) ?? "";
}

/**
 * The cached user is a CONVENIENCE for rendering — who is signed in, which
 * booth. It is never the authority: the server re-reads role, booth and active
 * status from the database on every single request, so editing this in devtools
 * changes what the console draws and nothing it is allowed to do.
 */
export function staffUser(): StaffUser | null {
  const raw = sessionStorage.getItem(STAFF_USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as StaffUser;
  } catch {
    return null;
  }
}

/** ISO string, or null when signed out. Purely so the UI can warn ahead of time. */
export function sessionExpiresAt(): string | null {
  return sessionStorage.getItem(STAFF_EXP_KEY);
}
